<script>
import { BC, BC_TRANS_JP, THIRD_LEVEL_MENU } from '@/components/pc/radio/ipradio/config/BCconstants.js'

export default {
  name: 'BCNetworkConfigurationThresholdTable',
  props: {
      first: {
          type: String,
          required: true
      },
      second: {
          type: String,
          required: true
      },
      setting: {
          type: Object,
          required: false,
      },
  },
  data() {
    return {
      // props を固定値として保持（元実装と同じ前提）
      firstLevel: this.first,
      secondLevel: this.second,
      thirdLevelName: THIRD_LEVEL_MENU[this.first][this.second][0].name,
      thirdLevelLabel: THIRD_LEVEL_MENU[this.first][this.second][0].label,
      thirdLevelItems: THIRD_LEVEL_MENU[this.first][this.second][0].item,

      tableData: [],
    }
  },
  created() {
    this.tableData = this.createTableRow()
  },
  methods: {
    createTableRow() {
      return this.thirdLevelItems.map((ele, d1Index) => {
        return {
          id: `${d1Index}`,
          label: ele.label,
          value: null,
          children: ele.item.map((child, d2Index) => {
            const src = this.setting[this.firstLevel][this.secondLevel][this.thirdLevelName][child.name]
            const isLTE = child.label === 'LTE'
            const disabled = src === BC.COMMON.TOGGLE.DISABLE
            const unit = isLTE ? 'dB' : 'dBm'
            const outOfRange = isLTE
              ? BC_TRANS_JP.NETWORK.CONFIGURATION.THRESHOLD.HANDOVER_LTE.OUT_OF_RANGE
              : BC_TRANS_JP.NETWORK.CONFIGURATION.THRESHOLD.HANDOVER_WIFI.OUT_OF_RANGE

            return {
              id: `${d1Index}-${d2Index}`,
              label: child.label,
              value: disabled ? outOfRange : `${src} ${unit}`,
            }
          }),
        }
      })
    },
  },
  computed: {
    BC() {
      return BC
    }
  },
}
</script>

<template>
  <el-table
    :data="tableData"
    row-key="id"
    :tree-props="{ children: 'children' }"
    :default-expand-all="true"
  >
    <el-table-column prop="label" :label="thirdLevelLabel" />
    <el-table-column prop="value" label="設定値" />
  </el-table>
</template>

<style scoped>
/* el-table の展開アイコンを非表示（Element UI 用の deep セレクタ） */
/deep/ .el-table__expand-icon,
/deep/ .el-tree-node__expand-icon,
/deep/ .el-table__placeholder {
  display: none !important;
}
</style>
